export const getProductShowcaseGraphQLQuery = (collectionTitle) => {
  return `{
    collections(query:"title:${collectionTitle}", first: 1) {
      edges {
        node {
          id
          title
          products(first: 48) {
            edges {
              node {
                id
                handle
                title
                availableForSale
                tags
                options {
                  id
                  name
                  values
                }
                images (first: 1) {
                  edges {
                    node {
                      altText
                      originalSrc
                    }
                  }
                }
                variants(first: 3) {
                  edges {
                    node {
                      id
                      availableForSale
                      title
                      compareAtPriceV2 {
                        amount
                      }
                      priceV2 {
                        amount
                      }
                    }
                  }
                }
                metafields(identifiers: [{namespace: "discount_banner", key: "discount_message"}, {namespace: "discount_banner", key: "discount_text_colour"}, {namespace: "discount_banner", key: "discount_banner_colour"}, , {namespace: "discount_banner", key: "discount_text_colour"}, {namespace: "global", key: "is_sample_kit"}, {namespace: "global", key: "linked_sample"} , {namespace: "global", key: "sample_kit_weight"}]) {
                  id
                  value
                  description
                  namespace
                  key
                }
              }
            }
          }
        }
      }
    }
    shop {
      metafields(identifiers: [{namespace: "globals", key: "g_discount_banner_message"}, {namespace: "globals", key: "g_discount_banner_text_colour"}, {namespace: "globals", key: "g_discount_banner_colour"}]) {
        id
        value
        description
        namespace
        key
      }
    }
  }`;
};
